import BlueButton from '../../components/blue-button';
import CountUp from '../../components/countup';
import {useRef} from 'react';
import {useDispatch} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {navigate} from '../../../utils/navigation';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';

export default ({index}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__bounceIn');
            modal.current.classList.add('animate__bounceOut');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('invite'));
            
            if(trigger === 'close')
                closePromotionModal('invite');
            else
                clickPromotionModal('invite', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal invite animate__animated animate__bounceIn animate__faster" ref={modal}>
                    <div className="invite-top-money"></div>
                    <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => {
                                closeAction('close');
                            }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="invite-title">Invite friends and claim<br/>reward</div>
                            <div className="invite-money">
                                <CountUp value={2000} prefix={'$'} decimals={0} duration={2} />
                            </div>
                            <div className="invite-slot">
                                <div className="slot">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
                                        <path d="M37 17.4633V19.5367H19.6289V37H17.3711V19.5367H0V17.4633H17.3711V0H19.6289V17.4633H37Z" fill="#4FACFE"/>
                                    </svg>
                                </div>
                                <div className="coins"></div>
                            </div>

                            <BlueButton onClick={e => {
                                closeAction('click', () => {
                                    navigate('/invite');
                                });
                            }}>Invite now</BlueButton>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}